// Runtime configuration loaded from /config.json (populated at deploy time by deploy.sh).
// Keeping this out of the bundle means one build artifact works against any environment.

export interface AppConfig {
  apiEndpoint: string;
  userPoolId: string;
  userPoolClientId: string;
  region: string;
}

let cached: AppConfig | null = null;

export async function loadConfig(): Promise<AppConfig> {
  if (cached) return cached;
  const res = await fetch('/config.json', { cache: 'no-store' });
  if (!res.ok) throw new Error(`Failed to load config.json: ${res.status}`);
  cached = (await res.json()) as AppConfig;
  return cached;
}
